import React from 'react'
import MaskedInputWrap from '.././maskedInputWrap.jsx'

const saveBlock = props => {
    let {
        tfa_code,
        codeReceived,
        changeNotificationStatus,
        inputFocus,
        changeTFAСode,
        changesCount,
        saveButtonClicked,
        tfaCodeRequestRequired,
        handleCodeReceivedChange,
    } = props

    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    if (!codeReceived && tfaCodeRequestRequired) return null

    return (
        <div className="code-confirm__getCode_save">
            <MaskedInputWrap
                type={'tfa_code'}
                value={tfa_code}
                reference={ref => {
                    inputFocus(ref)
                }}
                changeValue={changeTFAСode}
                placeholderChar={'\u2000'}
                placeholder={
                    tfaCodeRequestRequired
                        ? `${translation['Enter the received code']}...`
                        : `${translation['Enter the 2FA code']}...`
                }
            />
            <button
                className={
                    tfa_code.length === 6 && changesCount
                        ? 'code-confirm__getCode_secondButton __active'
                        : 'code-confirm__getCode_secondButton'
                }
                onClick={saveButtonClicked}
            >
                {`${translation['save'].slice(0, 1).toUpperCase()}${translation[
                    'save'
                ].slice(1)}`}
            </button>
            {tfaCodeRequestRequired ? (
                <button
                    className={'code-confirm__getCode_close'}
                    onClick={() => {
                        handleCodeReceivedChange()
                    }}
                >
                    {translation['Close']}
                </button>
            ) : null}
        </div>
    )
}

export default saveBlock
